export const SEARCH_PARAM_QUERY_NAME = "query";